/** Bump this when the terms text changes. Tutors are asked to accept again. */
export const TERMS_VERSION = '1.2';
export const PRIVACY_VERSION = '1.2';

export function hasAcceptedCurrentTerms(profile: {
  termsVersion?: string | null;
  termsAcceptedAt?: string | null;
} | null | undefined): boolean {
  return Boolean(profile?.termsAcceptedAt) && profile?.termsVersion === TERMS_VERSION;
}
